module.exports = __webpack_public_path__ + "e5edee04755f98056203184a6d6c7389.svg";